import React, { useEffect, useState, useRef, useMemo } from "react";

import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import DatePickerComponent from "../../client/components/DatePickerComponent";
import EasyGrid from "../../client/components/EasyGrid";
import axiosInstance from "../../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";
import $ from "jquery";
import ReactDOM1 from "react-dom/client";
import { isMobile } from "react-device-detect";
//import BetDetailsPopup from "../components/BetDetailsPopup";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import PlbyHierarchicalPopup from "../../agent/reports/PlbyHierarchicalPopup";
//plby-hierarchical

function toLocalString(d) {
  const pad = (x) => String(x).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

const BookDetails = () => {
  const [gridKey, setGridKey] = useState(Date.now());
  const [gridKey2, setGridKey2] = useState(Date.now());
  const [gridKey3, setGridKey3] = useState(Date.now());

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  const [profitUsers, setProfitUsers] = useState([]);
  const [lossUsers, setLossUsers] = useState([]);
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [profitLossDataLoad, setProfitLossDataLoad] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const [eventDetailsDisplay, setEventDetailsDisplay] = useState(false);
  const [detailsUsername, setDetailsUsername] = useState("");
  const [detailsMarketName, setDetailsMarketName] = useState("");

  const userInfo = useSelector((state) => state.userStore);

  let username = "";
  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo.data.uname;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };
  const getBookDetails = async (date) => {
    // let frm = startDate;
    // let til = endDate;

    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    setShowLoader(true);
    setEventDetailsDisplay(false);

    const response = await axiosInstance.post("master/report-by-all-users", {
      frm,
      til
    });
    if (response.status === 200) {
      const resData = response.data;

      setProfitUsers(resData.profit_users);
      setLossUsers(resData.loss_users);
      setTotalProfit(resData.totalProfit);
      setTotalLoss(resData.totalLoss);
      setProfitLossDataLoad(true);
      setShowLoader(false);
      setIsLoading(false);
      setGridKey(Date.now());
      setPlDataDetails([]);
      setSportwiseGrandTotal(null);
    }
  };

  const [filteredPlData, setFilteredPlData] = useState(null);
  const [plData, setPlData] = useState([]);
  const [plDataDetails, setPlDataDetails] = useState([]);
  /** From `pl-by-type-daily-report` (`grandTotal`); cleared on new report */
  const [sportwiseGrandTotal, setSportwiseGrandTotal] = useState(null);

  const betDetailsView = async (id) => {
    const popup = window.open(
      "/bet-details-view/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const betDetailsVirtualView = async (id) => {
    const popup = window.open(
      "/virtual-details-view/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const openPopUp = async (id) => {
    const popup = window.open(
      "/plby-hierarchical/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const handleClickDetails = async (row) => {
    let popup = null;
    if (row.user_role == 8) {
      if (row.game_type == 7 || row.game_type == 10) {
        popup = window.open(
          "/client-tp-details-view/" + row.id,
          "",
          "width=700,height=500"
        );
      } else if (row.game_type == 6) {
        betDetailsCasinoView(row.id);
      } else {
        if (row.game_type == 9) {
          popup = window.open(
            "/client-virtual-details-view/" + row.id,
            "",
            "width=700,height=500"
          );
        } else {
          popup = window.open(
            "/clinet-bet-details-view/" + row.id,
            "",
            "width=700,height=500"
          );
        }
      }
      if (popup) {
        popup.document.title = "BPEXCH";
      }
    } else {
      openPopUp(row.id);
    }

    /* if (row.user_role == 8) {
      if (row.game_type == 9) {
        betDetailsVirtualView(row.id);
      } else {
        betDetailsView(row.id);
      }
    } else {
      openPopUp(row.id);
    }*/
  };

  const betDetailsCasinoView = async (id) => {
    const popup = window.open(
      "/client-casino-details-view/" + id,
      "",
      "width=700,height=500"
    );

    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };
  const handleUserClick = async (user) => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);

    setShowLoader(true);
    setDetailsUsername(user.uname);
    setSportwiseGrandTotal(null);
    const response = await axiosInstance.post(
      "master/pl-by-type-daily-report",
      {
        userId: user.user_id,
        frm,
        til
      }
    );
    setPlDataDetails([]);
    setPlData(
      response.data.data.map((item, idx) => ({
        ...item,
        _id: item._id ?? `${item.market_name}_${idx}_${Math.random()}`
      }))
    );

    setShowLoader(false);
    setEventDetailsDisplay(true);
    const exclude = ["user_id", "from", "to", "grandTotal"];
    setFilteredPlData(
      Object.fromEntries(
        Object.entries(response.data).filter(([key]) => !exclude.includes(key))
      )
    );

    const rows = Array.isArray(response.data.data) ? response.data.data : [];
    const gtRaw = response.data.grandTotal;
    let gtNum =
      gtRaw !== undefined && gtRaw !== null && gtRaw !== ""
        ? Number(gtRaw)
        : NaN;
    if (Number.isNaN(gtNum)) {
      gtNum = rows.reduce((s, r) => {
        const n = Number(r.amount);
        return s + (Number.isNaN(n) ? 0 : n);
      }, 0);
    }
    setSportwiseGrandTotal(Number.isNaN(gtNum) ? null : gtNum);

    setGridKey2(Date.now());
  };
  const handleUserClick3 = async (user) => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    setShowLoader(true);

    setDetailsMarketName(user.market_name);
    const response = await axiosInstance.post(
      "master/book-detail/pl-by-type-bet-list",
      {
        userId: user.user_id,
        game_type: user.game_type,
        market_type: user.market_type,
        frm,
        til
      }
    );

    setPlDataDetails(
      response.data.betList.map((item, idx) => ({
        ...item,
        _id: item._id ?? item.tid ?? `${item.match}_${idx}_${Math.random()}`
      }))
    );

    setShowLoader(false);

    setGridKey3(Date.now());
  };

  // Adding datatable below:

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);
  const gridTableRef = useRef(null);
  const gridTableRef2 = useRef(null);
  const defaultExpand = true;
  function escapeHtml(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
  const cols = useMemo(
    () => [
      {
        title: "Name",
        data: "uname",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:#00b181;cursor:pointer;padding-left:4px">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "winAmount",
        render: (d) =>
          d < 0
            ? `<span style="color:red">${formatTruncate(Math.round(d))}</span>`
            : `<span style="color:#0b6222">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  const cols3 = useMemo(
    () => [
      {
        title: "Event",
        data: "market_name",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:#00b181;cursor:pointer;padding-left:4px">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "amount",
        render: (d) =>
          d < 0
            ? `<span style="color:red">${formatTruncate(Math.round(d))}</span>`
            : `<span style="color:#0b6222">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  const colsDetails = useMemo(
    () => [
      {
        title: "Date",
        data: "stmp",
        order: "asc",
        width: isMobile ? "50px" : "200px",
        className: "dt-right",
        responsivePriority: 2,
        render: (d, type) => {
          if (type === "display" || type === "filter") {
            if (!d) return "";
            const dt = new Date(d);
            const datePart = dt.toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric"
            });
            const fullTime = dt.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            // Split "04:47 pm" into time "04:47" and meridiem "pm"
            const meridiemMatch = fullTime.match(/^([\d:]+)\s*(am|pm)$/i);
            if (meridiemMatch) {
              const hhmm = meridiemMatch[1];
              const meridiem = meridiemMatch[2];
              if (isMobile) {
                return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem;font-weight:400">${datePart}</span><span class="date-time-block"><br><span class="date-time" style="font-size:1rem;font-weight:400">${hhmm}</span><br> <span class="date-meridiem" style="font-size:1rem;font-weight:400">${meridiem}</span></span></span>`;
              } else {
                return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem;font-weight:400">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem;font-weight:400">${hhmm}</span><span class="date-meridiem" style="font-size:1rem;font-weight:400">${meridiem}</span></span></span>`;
              }
            }
            return `<span class="date-cell-wrap"><span class="date-part" style="font-size:1rem;font-weight:400">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:1rem;font-weight:400">${fullTime}</span></span></span>`;
          }
          return d ? new Date(d).getTime() : 0;
          /*
          if (type === "display" || type === "filter") {
            return d ? new Date(d).toLocaleString() : "";
          } 
          return d ? new Date(d).getTime() : 0;*/
        }
      },
      {
        title: "Event",
        data: "match",
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:#00b181;cursor:pointer;padding-left:4px;word-wrap:anywhere;font-size:1rem;">${safe}</a>`;
        },
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 3
      },
      {
        title: "Amount",
        data: "win_amt",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));

          return safe < 0
            ? `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:red;cursor:pointer">${formatTruncate(
                safe
              )}</a>`
            : `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:#0b6222;cursor:pointer">${formatTruncate(
                safe
              )}</a>`;
        }
      }
    ],
    []
  );

  useEffect(() => {
    getBookDetails();
  }, []);

  const sportwiseGrandTotalValid = sportwiseGrandTotal !== null;
  const sportwiseGrandTotalProfit =
    sportwiseGrandTotalValid && sportwiseGrandTotal > 0;
  const sportwiseGrandTotalLoss =
    sportwiseGrandTotalValid && sportwiseGrandTotal < 0;

  return (
    <AgentLayout>
      <style>{`.react-datepicker-popper {
             left: unset;
        }
        @media (max-width: 640px) {
          #ReportFilterForm .row > .col-12.col-md-5 {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 8px;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker-wrapper,
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker__input-container,
          #ReportFilterForm .row > .col-12.col-md-5 .form-group,
          #ReportFilterForm .row > .col-12.col-md-5 .input-group {
            width: 100% !important;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group .form-control {
            flex: 1;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group-addon {
            display: flex;
            align-items: center;
          }
          #ReportFilterForm .input-group {
            flex-wrap: nowrap !important;
          }
          #ReportFilterForm .input-group .input-group-addon {
            display: flex;
            align-items: stretch;
          }
          #ReportFilterForm .input-group .input-group-addon .input-group-text {
            display: flex;
            align-items: center;
            align-self: stretch;
            height: auto;
            padding: 0 0.75rem;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            border-left: none;
            border-radius: 0 0.25rem 0.25rem 0;
          }
          #ReportFilterForm .input-group .form-control {
            border-radius: 0.25rem 0 0 0.25rem;
          }
          #ReportFilterForm .row > strong {
            display: none;
          }
          #ReportFilterForm .row > .editsbmtbtn {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-right: 20px;
          }
        }`}</style>
      <div className="container-fluid">
        <div
          className="loaderAgent"
          style={{ display: showLoader ? "" : "none" }}
        >
          <img src="/assets/images/loadinggif.gif" />
        </div>

        <div className="bets-section-wrapper">
          <div>
            <NavButton></NavButton>
          </div>

          <div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <i className="fa fa-filter"></i>
                    <strong className="site_family">Report Filter</strong>
                  </div>
                  <div
                    className="card-body"
                    style={{ padding: "0.8rem 1.25rem" }}
                  >
                    <form
                      id="ReportFilterForm"
                      className="form-inline"
                      method="get"
                      style={{ padding: "5px" }}
                    >
                      <div className="row" style={{ textAlignLast: "justify" }}>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportFrom"
                            inputId="DisplayFrom"
                            defaultDate={startDate}
                            setSelectedDate={startDateSet}
                          />
                          {/*<DatePickerComponent
                            defaultDate={startDate}
                          setSelectedDate={startDateSet}/>*/}
                        </div>
                        <strong style={{ margin: "auto" }}>
                          &nbsp;-&nbsp;
                        </strong>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportTo"
                            inputId="DisplayTo"
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                          />

                          {/*<DatePickerComponent
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                          />*/}
                        </div>
                        <div className="form-group editsbmtbtn">
                          <button
                            onClick={() => getBookDetails()}
                            className="btn btn-success"
                            style={{ background: "#02b181" }}
                            type="button"
                          >
                            <strong>Submit</strong>
                          </button>
                        </div>
                      </div>
                      <div className="row col-12"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="bets-wrapper"
          style={{
            marginTop: "0px",
            display: profitLossDataLoad ? "" : "none"
          }}
        >
          <div className="row">
            <div className="col-md-6" style={{ marginTop: "0px" }}>
              <div className="card">
                <div className="card-header site_family">
                  <div style={{ float: "left" }}>
                    <i className="fa fa-align-justify"></i>
                    <span style={{ fontWeight: "600" }}> Report</span>
                  </div>
                  <div style={{ float: "right" }}>
                    {" "}
                    <span
                      className="loader"
                      id="span_loader_report"
                      style={{ top: "10px", left: "10px", display: "none" }}
                    ></span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row no-gutters">
                    <div className="col-6 pr-1">
                      <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                              <div className="row">
                                <div className="col-sm-12 col-md-6"></div>
                                <div className="col-sm-12 col-md-6"></div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  {profitUsers.length > 0 && (
                                    <div>
                                      <EasyGrid
                                        responsiveMode="hybrid"
                                        cols={cols}
                                        dataset={profitUsers}
                                        isLoading={isLoading}
                                        pageSize={pageSize}
                                        handleUserClick={handleUserClick}
                                      ></EasyGrid>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-5"></div>
                                <div className="col-sm-12 col-md-7"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-5"></div>
                          <div className="col-sm-12 col-md-7"></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 pl-1">
                      <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                              {lossUsers.length > 0 && (
                                <div>
                                  <EasyGrid
                                    responsiveMode="hybrid"
                                    cols={cols}
                                    dataset={lossUsers}
                                    isLoading={isLoading}
                                    pageSize={pageSize}
                                    handleUserClick={handleUserClick}
                                  ></EasyGrid>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-5"></div>
                          <div className="col-sm-12 col-md-7"></div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6 pr-1">
                      <table className="table table-sm dataTable">
                        <tbody>
                          <tr style={{ color: "white", background: "#02b382" }}>
                            <td
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              Total
                            </td>
                            <td
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              {formatTruncate(Math.round(totalProfit))}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-6 pl-1">
                      <table className="table table-sm">
                        <tr className="bg-danger" style={{ color: "white" }}>
                          <td
                            className="site_family"
                            style={{ fontWeight: "bold" }}
                          >
                            Total
                          </td>
                          <td>
                            <span
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              {formatTruncate(Math.round(totalLoss))}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-md-6"
              style={{
                marginTop: "3px",
                display: eventDetailsDisplay ? "" : "none"
              }}
            >
              <div>
                <div className="card">
                  <div className="card-header">
                    <div style={{ float: "left" }}>
                      <i className="fa fa-align-justify"></i>

                      <span
                        className="site_family"
                        style={{ fontWeight: "bold", paddingLeft: "10px" }}
                      >
                        {" "}
                        {detailsUsername}- Sportwise Report
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    {plData.length > 0 && (
                      <div>
                        <EasyGrid
                          responsiveMode="hybrid"
                          cols={cols3}
                          dataset={plData}
                          isLoading={isLoading}
                          pageSize={pageSize}
                          ordering={false}
                          handleUserClick={handleUserClick3}
                        ></EasyGrid>
                      </div>
                    )}
                    {eventDetailsDisplay && sportwiseGrandTotalValid && (
                      <table
                        className={`table table-sm${
                          sportwiseGrandTotalProfit ? " dataTable" : ""
                        }`}
                      >
                        <tbody>
                          <tr
                            style={{
                              background: sportwiseGrandTotalProfit
                                ? "#00b483"
                                : sportwiseGrandTotalLoss
                                ? "#f86d6b"
                                : "#00b483",
                              color: "white"
                            }}
                          >
                            <td
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              Total
                            </td>
                            <td
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              {formatTruncate(Math.round(sportwiseGrandTotal))}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "20px", display: "" }}>
                {plDataDetails.length > 0 && (
                  <div className="card">
                    <div className="card-header">
                      <div style={{ float: "left" }}>
                        <i className="fa fa-align-justify"></i>
                        <span
                          style={{ paddingLeft: "8px", fontWeight: "bold" }}
                          className="site_family"
                        >
                          {detailsUsername} / {detailsMarketName}-Markets
                          Reports
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      {plDataDetails.length > 0 && (
                        <div>
                          <EasyGrid
                            responsiveMode="hybrid"
                            cols={colsDetails}
                            dataset={plDataDetails}
                            isLoading={isLoading}
                            pageSize={pageSize}
                            ordering={false}
                            handleUserClick={handleClickDetails}
                          ></EasyGrid>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <style>{`

.loaderAgent {
   
  position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: .6;
    display: flex;
    justify-content: center;
    align-items: center; 
  background-image:
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0);
  background-repeat: no-repeat;
  background-size: 20px auto;
  background-position: 0 0, 40px 0, 80px 0, 120px 0;
  animation: pgfill 1s linear infinite;
}

@keyframes pgfill {
  0% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  25% {
      background-image: linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  50% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  75% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  100% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0);
  }
}

`}</style>
      </div>
    </AgentLayout>
  );
};

export default BookDetails;
